
/**
 * Scan a page a find Modals with YouTube videos embedded in them; Ensure the JS API for YouTube
 * is enabled; when modals are closed, stop the videos
 * @returns void
 */
export const monitorModalYoutubeVideos = () => {    
    
    const modalTriggerList = document.querySelectorAll('.modal')

    if (!modalTriggerList || modalTriggerList.length === 0) {
        // nothing to see here; no modals on this page
        return;
    }    
    
    // extract the youtube video modals; thats all we care about here
    const videoModals = [...modalTriggerList].filter(m => {
        if (m.querySelectorAll('iframe[src*="youtube"]').length > 0) {
            return true;
        }           
        return false;
    });
   

    // apply ops to the video modals
    videoModals.map(modalEl => {        

        // add on page-load

        // ensure that the video link is prepared properly
        const iframe = modalEl.querySelector('iframe[src*="youtube"]');
        if (iframe) {
            
            // enable the JS API on the youtube url if its not already
            // this enables us to interact with youtube programically
            const urlString = iframe.getAttribute('src');               
            const videoUrl = new URL(urlString);
            urlString.includes('?') ?
                videoUrl.searchParams.append('enablejsapi', 1) :
                videoUrl.searchParams.set('enablejsapi', 1);
            
            iframe.setAttribute('src', videoUrl);
        }       

        // add event hooks for videos
        
        // fired after the modal is hidden
        modalEl.addEventListener('hidden.bs.modal', event => {

            // find and remove the src; this will stop playback
            const iframe = event.target.querySelector('iframe[src*="youtube"]');
            if (iframe) {                                
                iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }
        });
    });    
}